/**
 * NEXT_PUBLIC_APP_ENV has only two values across the FE_PDAP_* ADO variable
 * groups: 'development' on DEV/SIT/UAT and 'production' on PPD/PROD.
 */
export const APP_ENVS = {
  development: 'development',
  production: 'production',
} as const;

export type AppEnv = (typeof APP_ENVS)[keyof typeof APP_ENVS];

export const isDevEnvironment =
  process.env.NEXT_PUBLIC_APP_ENV === APP_ENVS.development;
